"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateCurrentRouteForUser = exports.rehydrateSession = exports.logoutAndRedirect = exports.isCurrentRouteAnonymous = exports.impersonateAgentRedirect = exports.getSSOSession = exports.createCurrentRouteRedirectUrl = exports.changeAgencyView = exports.agentUnauthorizedAndRedirect = void 0;
var routes = _interopRequireWildcard(require("../constants/routes"));
var _axios = _interopRequireDefault(require("axios"));
var _ = require("../");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ssoBaseUrlAPI = window.env && window.env.REACT_APP_SSO_BASEURL;
var getSSOSession = exports.getSSOSession = function getSSOSession(accessToken) {
  var ssoSessionAPI = _axios["default"].create({
    baseURL: ssoBaseUrlAPI,
    headers: {
      Authorization: "Bearer ".concat(accessToken)
    },
    withCredentials: true
  });
  return ssoSessionAPI.get("identity/session");
};
var anonymousRoutes = [routes.OIDC_SSO_CALLBACK];
var isCurrentRouteAnonymous = exports.isCurrentRouteAnonymous = function isCurrentRouteAnonymous() {
  var currentRoute = window.location.pathname;
  var found = anonymousRoutes && anonymousRoutes.find(function (route) {
    return currentRoute && currentRoute.toLowerCase().indexOf(route) > -1;
  });
  return found;
};
var createCurrentRouteRedirectUrl = exports.createCurrentRouteRedirectUrl = function createCurrentRouteRedirectUrl() {
  var basepath = _.ssoClient.ssoConfiguration && _.ssoClient.ssoConfiguration.basepath;
  var currentRouteQueryString = window.location.search;
  var currentRoute = window.location.pathname;
  return basepath ? currentRoute ? "".concat(currentRoute.split(basepath).join("") || "/").concat(currentRouteQueryString ? currentRouteQueryString : "") : routes.HOME : currentRoute ? "".concat(currentRoute).concat(currentRouteQueryString ? currentRouteQueryString : "") : routes.HOME;
};
var validateCurrentRouteForUser = exports.validateCurrentRouteForUser = function validateCurrentRouteForUser(userManager, user, completedCallback, redirectUrl) {
  if (!user && !isCurrentRouteAnonymous()) {
    var signinConfig = {
      state: {
        redirectUrl: redirectUrl ? redirectUrl : createCurrentRouteRedirectUrl()
      }
    };
    userManager.signinRedirect(signinConfig).then(function () {
      if (completedCallback) {
        completedCallback();
      }
    });
  } else if (completedCallback) {
    completedCallback();
  }
};
var buildSignoutConfig = function buildSignoutConfig(user, postLogoutRedirectUri) {
  return {
    id_token_hint: user && user.id_token,
    post_logout_redirect_uri: postLogoutRedirectUri ? postLogoutRedirectUri : isCurrentRouteAnonymous() ? routes.HOME : "".concat(createCurrentRouteRedirectUrl().replace("&#", "#"))
  };
};
var logoutAndRedirect = exports.logoutAndRedirect = function logoutAndRedirect(userManager, user, completedCallback) {
  var postLogoutRedirectUri = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  userManager.removeUser().then(function () {
    var config = buildSignoutConfig(user, postLogoutRedirectUri);
    userManager.signoutRedirect(config).then(function () {
      return null;
    });
  });
};
var changeAgencyView = exports.changeAgencyView = function changeAgencyView(userManager, agencyCode, clientId, completedCallback) {
  var redirectUrl = encodeURIComponent("".concat(window.location.origin).concat(createCurrentRouteRedirectUrl().replace("&#", "#")));
  var route = "".concat(ssoBaseUrlAPI, "identity/resetagency/").concat(agencyCode, "?ClientId=").concat(clientId, "&RedirectUrl=").concat(redirectUrl);
  window.localStorage.clear();
  window.sessionStorage.clear();
  window.location = route;
  if (completedCallback) {
    completedCallback();
  }
};
var rehydrateSession = exports.rehydrateSession = function rehydrateSession(userManager, clientId, completedCallback, redirectRoute) {
  var redirectUrl = encodeURIComponent("".concat(window.location.origin).concat((redirectRoute || createCurrentRouteRedirectUrl()).replace("&#", "#")));
  var route = "".concat(ssoBaseUrlAPI, "identity/rehydrate-session?ClientId=").concat(clientId, "&RedirectUrl=").concat(redirectUrl);
  window.localStorage.clear();
  window.sessionStorage.clear();
  window.location = route;
  if (completedCallback) {
    completedCallback();
  }
};
var agentUnauthorizedAndRedirect = exports.agentUnauthorizedAndRedirect = function agentUnauthorizedAndRedirect(userManager, applicationId, completedCallback) {
  window.sessionStorage.clear();
  window.localStorage.clear();
  window.location = "".concat(ssoBaseUrlAPI, "Unauthorized/").concat(applicationId);
  if (completedCallback) {
    completedCallback();
  }
};
var impersonateAgentRedirect = exports.impersonateAgentRedirect = function impersonateAgentRedirect(userManager, applicationId, userId, completedCallback, redirectUrl) {
  var returnUrl = encodeURIComponent(redirectUrl || "".concat(window.location.origin).concat(createCurrentRouteRedirectUrl()));
  var impersonateAgentUrl = "".concat(ssoBaseUrlAPI).concat(routes.SSO_AGENT_IMPERSONATION, "?ApplicationID=").concat(applicationId, "&ReturnUrl=%2f&RedirectUrl=").concat(returnUrl, "&clientId=").concat(userManager.settings.client_id);
  impersonateAgentUrl = userId ? "".concat(impersonateAgentUrl, "&userID=").concat(userId) : impersonateAgentUrl;
  window.localStorage.clear();
  window.sessionStorage.clear();
  window.location = impersonateAgentUrl;
  if (completedCallback) {
    completedCallback();
  }
};